import restrictNumber from './restrictNumber';

export const FONT_SIZE_MIN = 1;
export const FONT_SIZE_MAX = 150;

/** Whole-pixel font size for UI and canvas (templates may store long decimals). */
export const normalizeFontSize = (value) => {
  if (value === '' || value == null || Number.isNaN(Number(value))) {
    return '';
  }
  return Math.round(restrictNumber(value, FONT_SIZE_MIN, FONT_SIZE_MAX));
};

export const fontSizeNeedsNormalization = (value) => {
  if (value === '' || value == null || Number.isNaN(Number(value))) {
    return false;
  }
  return normalizeFontSize(value) !== Number(value);
};
